module.exports = __webpack_public_path__ + "img/map-pin.c22ede77.svg";